// import './App.css';
import { useEffect, useState } from "react";
import { getSetting, send, setSetting, subscribeSetting, buriedPoints, gTagConfig } from "../service";
import { request, debounce } from "../utils/index";
import { emailRule, passwordRule, ERROR_MESSAGE } from "../const";
import Tips from "./components/Tips";
import { EyeOff } from "./components/LeftIcon";

export default function Form({ closeAll, setting, h5LinkClick, loginWordClick, descWords, setSaveLogin, saveLogin }) {
    const form1 = {
        email: '',
        password: '',
    }

    const form2 = {
        email: '',
        password: '',
    }

    const formKey = Object.keys(form1)
    let submitBtn1, submitBtn2, eye1, eye2, resendBtn1, resendBtn2

    const [eye1Show, setEye1Show] = useState(false)
    const [eye2Show, setEye2Show] = useState(false)
    const [success, setSuccess] = useState(false)
    const [loginForm, setLoginForm] = useState(form1)
    const [checked, setChecked] = useState(false)

    function getUTM(name, utms) {
        return utms[name] || ''
    }

    const { searchParams = {}, localStorageUtm = {}, marketingUtm = {}, } = getSetting();
    let utms = searchParams.utm_source ? searchParams : localStorageUtm.utm_source ? localStorageUtm : marketingUtm.utm_source ? marketingUtm : {}
    const defaultParams = {
        'utm_source': getUTM('utm_source', utms) || "Freemium",
        'utm_content': getUTM('utm_content', utms),
        'utm_medium': getUTM('utm_medium', utms),
        'utm_campaign': getUTM('utm_campaign', utms),
        'utm_term': getUTM('utm_term', utms),
    }

    useEffect(() => {
        debounce(() => {
            if (!setting.isLogin) {
                buriedPoints("Freemium_Register popup", {
                    Page: setting.originHref,
                    Source: defaultParams.utm_source, ...defaultParams
                })
            } else {
                buriedPoints("Login Pop Up Shows", { Page: setting.originHref, ...defaultParams })
            }
        }, 100)

    }, [setting.isLogin])

    useEffect(() => {
        submitBtn1 = document.getElementById('submit-btn-1')
        submitBtn2 = document.getElementById('submit-btn-2')
        resendBtn1 = document.getElementById('resend-btn-1')
        resendBtn2 = document.getElementById('resend-btn-2')

        resendBtn1.addEventListener('click', resend(1, resendBtn1))
        resendBtn2.addEventListener('click', resend(2, resendBtn2))

        submitBtn1.addEventListener('click', submit(1, submitBtn1))
        submitBtn2.addEventListener('click', submit(2, submitBtn2))

        formKey.forEach(item => {
            const element1 = document.getElementById(`lable-input-${item}-1`)
            const element2 = document.getElementById(`lable-input-${item}-2`)

            element1.addEventListener('input', function (e) {
                inputEvent(e, 1)
            })
            element2.addEventListener('input', function (e) {
                inputEvent(e, 2)
            })
            element1.addEventListener('blur', function (e) {
                blurEvent(e, element1)
            })
            element2.addEventListener('blur', function (e) {
                blurEvent(e, element2)
            })
        })
        for (let i = 1; i < 3; i++) {
            changeRegistorStatus({
                show: [document.getElementById(`registor-none-${i}`)],
                hidden: [document.getElementById(`registor-success-${i}`),
                document.getElementById(`registor-loading-${i}`)],
            })
        }

    }, [])

    function resend(num, element) {
        return () => {
            titleShowChange(true)
            changeRegistorStatus({
                show: [document.getElementById(`registor-loading-${num}`)],
                hidden: [document.getElementById(`registor-none-${num}`),
                document.getElementById(`registor-success-${num}`)]
            })
            const form = eval(`form${num}`)
            function reslove(res) {
                const successWord = document.getElementById(`success-word-${num}`)
                changeRegistorStatus({
                    show: [document.getElementById(`registor-success-${num}`)],
                    hidden: [document.getElementById(`registor-none-${num}`),
                    document.getElementById(`registor-loading-${num}`)]
                })
                titleShowChange(false)
                if (res.code == 200) {
                    const node1 = document.createElement("span"), node2 = document.createElement("b"), node3 = document.createElement("span");
                    node1.innerText = "Activation email has been resent. Please click the link we sent to ";
                    node2.innerText = form.email;
                    node3.innerText = ". Make sure to check your spam folder.";
                    if(successWord){
                        successWord.innerHTML = "";
                        successWord.appendChild(node1) 
                        successWord.appendChild(node2)
                        successWord.appendChild(node3)  
                    }
                } else {
                    successWord && (successWord.innerText = res.message)
                }
            }
            function timeoutCb() {
                send({ action: 'apiMessage', type: "error", message: ERROR_MESSAGE })
                changeRegistorStatus({
                    show: [document.getElementById(`registor-success-${num}`)],
                    hidden: [document.getElementById(`registor-none-${num}`),
                    document.getElementById(`registor-loading-${num}`)]
                })
            }
            debounce(() => request({
                url: 'fleet/register/freemium/email/resend?email=' + form.email,
                method: 'get',
                reslove,
                timeoutCb,
            }), 10, true)
        }
    }

    function changeRegistorStatus({ show, hidden }) {
        show.forEach(item => {
            item.style.display = "flex"
        })
        hidden.forEach(item => {
            item.style.display = "none"
        })
    }

    function blurEvent(e, element) {
        let val = e.target.value.trim()
        const classList = [...e.target.classList]
        const type = formKey.filter(i => classList.includes(i))[0]
        e.target.value = val
        if (type === "email") {
            if (verify(type, val, element)) {
                !getSetting().isLogin && checkEmail(val, emailCb, element)
            } else {
                element.classList.remove('email-already')
            }
        }
        else {
            verify(type, val, element)
        }

    }
    function inputEvent(e, num, newVal, newTarget) {
        let val = typeof newVal !== "undefined" ? newVal : e.target.value.trim(), pass = true
        const classList = newTarget ? [...newTarget.classList] : [...e.target.classList]
        const otherKey = formKey.filter(i => !classList.includes(i))
        const nowKey = formKey.filter(i => classList.includes(i))[0]
        const form = eval(`form${num}`)
        const submitBtn = document.getElementById(`submit-btn-${num}`)
        for (let i = 0; i < otherKey.length; i++) {
            if (!form[otherKey[i]]) {
                pass = false
                break
            }
        }
        form[nowKey] = val
        if (pass && val) {
            submitBtn && submitBtn.classList.add('can-click')
        } else {
            submitBtn && submitBtn.classList.remove('can-click')
        }

    }
    function verify(type, val, element) {
        const nowRule = type === "email" ? emailRule : passwordRule;
        return verifyHandle(type, val, element, nowRule)
    }
    function verifyHandle(type, val, element, rule) {
        if (!val) {
            element.classList.remove('input-has', 'input-error')
            element.classList.add('input-requried')
            return false
        } else {
            if (!rule) element.classList.remove('input-requried')
            if (rule && !rule.test(val)) {
                element.classList.add('input-error')
                element.classList.remove('input-requried')
                return false
            } else {
                let form = 0
                if (element.id.includes(1)) {
                    form = form1
                } else {
                    form = form2
                }
                element.classList.remove('input-error', 'input-requried')
                element.classList.add('input-has')
                form[type] = val
                return true
            }
        }
    }
    let set
    function submit(num, element1) {
        return () => {
            if (!getSetting().isLogin) {
                buriedPoints("Sign Up Button Clicked", defaultParams)
            }
            if (![...element1.classList].includes("can-click")) return
            element1.classList.add('loading')
            const form = eval(`form${num}`)
            let pass = true
            for (let i = 0; i < formKey.length; i++) {
                const item = formKey[i]
                const element = document.getElementById(`lable-input-${item}-${num}`)
                if (!verify(item, form[item], element)) {
                    pass = false
                }
            }
            if (!pass) {
                element1.classList.remove('loading')
            } else {
                changeRegistorStatus({
                    show: [document.getElementById(`registor-loading-${num}`)],
                    hidden: [document.getElementById(`registor-none-${num}`), document.getElementById(`registor-success-${num}`)]
                })
                subscribeSetting(s => {
                    set = s
                })
                if (!set.isLogin) {
                    register(form, num)
                }
            }
        }
    }
    useEffect(() => {
        if (getSetting().isLogin || !getSetting().isForgetPassword) {
            emailCb({ data: null }, document.getElementById(`lable-input-email-1`))
            emailCb({ data: null }, document.getElementById(`lable-input-email-2`))
            passwordCb(document.getElementById(`lable-input-password-1`))
            rememUserBack()
            loginForm.email && document.getElementById(`lable-input-email-1`).dispatchEvent(new Event("blur"))
            loginForm.password && document.getElementById(`lable-input-password-1`).dispatchEvent(new Event("blur"))
        }
    }, [getSetting().isLogin, getSetting().isForgetPassword])

    function emailCb(res, element) {
        if ((res.data && res.data.id) || res.message === "You're already a COMMAND user, please log in" || res.message === "This email has been used.") {
            element.classList.add('email-already')
            element.classList.remove('input-requried', 'input-error')
        } else {
            element.classList.remove('email-already', 'input-error', 'input-requried')
        }
    }
    function passwordCb(element) {
        if (!element.value) {
            element.classList.remove('email-already', 'input-error', 'input-requried')
        }
    }
    function checkEmail(email, callback, element) {
        function reslove(res) {
            callback(res, element);
        }
        debounce(() => request({
            url: 'fleet/user/check/invite/admin?email=' + email,
            method: 'get',
            reslove,
        }), 10, true)
    }

    function register(formData, num) {
        subscribeSetting(s => {
            set = s
        })
        const { searchParams = {}, localStorageUtm = {}, marketingUtm = {}, originHref, shareId, editionType } = set
        let utms = searchParams.utm_source ? searchParams : localStorageUtm.utm_source ? localStorageUtm : marketingUtm.utm_source ? marketingUtm : {}
        const utm = getUTM('utm_source', utms) || "Freemium"
        const { email, password } = formData
        const data = {
            email, password,
            utm,
            editionType,
            marketingUtm: {
                source: utm,
                content: getUTM('utm_content', utms),
                medium: getUTM('utm_medium', utms),
                campaign: getUTM('utm_campaign', utms),
                term: getUTM('utm_term', utms),
                sourceLink: originHref
            }
        }
        if (shareId) {
            data.shareId = shareId
        }
        function reslove(res) {
            if (res.code == 200) {
                send({ action: 'success' })
                titleShowChange(false)
                changeRegistorStatus({
                    show: [document.getElementById(`registor-success-${num}`)],
                    hidden: [document.getElementById(`registor-loading-${num}`), document.getElementById(`registor-none-${num}`)]
                })
                gTagConfig("MEASUREMENT_ID", { "user_id": res.data })
                buriedPoints("Register Success", {
                    Outcome: "Free Trial",
                    Source: utm,
                    ...defaultParams
                })
                buriedPoints("Create Account", {
                    Page: originHref,
                    ...defaultParams
                })

                buriedPoints("Sign Up Result", { result: "Success", "user_id": res.data, ...defaultParams })

                const successWord = document.getElementById(`success-word-${num}`)
                const node1 = document.createElement("span"), node2 = document.createElement("b"), node3 = document.createElement("span");
                node1.innerText = "To activate your account, click the link we sent to ";
                node2.innerText = email;
                node3.innerText = ". Make sure to check your spam folder.";
                if(successWord){
                    successWord.innerHTML = "";
                    successWord.appendChild(node1) 
                    successWord.appendChild(node2)
                    successWord.appendChild(node3)  
                }

                setSuccess(true)
            } else {
                buriedPoints("Sign Up Result", { result: "Failed", ...defaultParams })
                changeRegistorStatus({
                    show: [document.getElementById(`registor-none-${num}`)],
                    hidden: [document.getElementById(`registor-loading-${num}`), document.getElementById(`registor-success-${num}`)]
                })
                emailCb(res, document.getElementById(`lable-input-email-${num}`))
            }
        }
        function timeoutCb() {
            send({ action: 'apiMessage', type: "error", message: ERROR_MESSAGE })
            changeRegistorStatus({
                show: [document.getElementById(`registor-none-${num}`)],
                hidden: [document.getElementById(`registor-loading-${num}`), document.getElementById(`registor-success-${num}`)]
            })
        }
        debounce(() => {
            buriedPoints("Sign Up Button Click", defaultParams)

            request({
                url: 'fleet/register/freemium',
                data,
                method: 'post',
                reslove: reslove,
                timeoutCb
            })
        }, 10, true)
    }

    function login(formData, num) {
        function timeoutCb() {
            send({ action: 'apiMessage', type: "error", message: ERROR_MESSAGE })
            changeRegistorStatus({
                show: [document.getElementById(`registor-none-${num}`)],
                hidden: [document.getElementById(`registor-success-${num}`),
                document.getElementById(`registor-loading-${num}`)]
            })
        }
        function reslove(res) {
            if (res.code === 200) {
                buriedPoints("User Login", { outcome: true, ...defaultParams })
                function resloveMe(resMe) {
                    if (resMe.code === 200) {
                        send({
                            action: 'loginSuccess',
                            token: res.data.token,
                            companyVersion: res.data.companyVersion,
                            meInfo: resMe.data,
                            userInfo: { rememUser: checked, email: formData.email }
                        })
                        buriedPoints("User Login", { outcome: true, ...defaultParams })
                    } else {
                        let msg = resMe.message
                        if (msg) {
                            msg = msg.charAt(0).toUpperCase() + msg.slice(1)
                        }
                        send({ action: 'apiMessage', type: "error", message: msg || 'Fail to login' })
                        changeRegistorStatus({
                            show: [document.getElementById(`registor-none-${num}`)],
                            hidden: [document.getElementById(`registor-success-${num}`),
                            document.getElementById(`registor-loading-${num}`)]
                        })
                    }
                }
                debounce(() => {
                    const { email, password } = formData
                    const data = {
                        email,
                        password,
                        rememUser: checked
                    }
                    request({
                        url: "fleet/user/info/me",
                        method: 'get',
                        reslove: resloveMe,
                        portalToken: res.data.token,
                        timeoutCb
                    })
                }, 10, true)


            } else {
                let msg = (res.message && res.message !== "email or password error") ? res.message : "Your email or password is incorrect"
                send({ action: 'apiMessage', type: "error", message: msg })
                changeRegistorStatus({
                    show: [document.getElementById(`registor-none-1`)],
                    hidden: [document.getElementById(`registor-success-1`),
                    document.getElementById(`registor-loading-1`)]
                })
                const errorDom = document.getElementById("login-error");
                errorDom && (errorDom.innerText = res.message)
                buriedPoints("User Login", { outcome: false, ...defaultParams })
            }
        }
        debounce(() => {
            const { email, password } = formData
            const data = {
                email,
                password,
                rememUser: checked
            }
            request({
                url: 'fleet/login',
                data,
                method: 'post',
                reslove: reslove,
                timeoutCb
            })
        }, 10, true)
    }
    function titleShowChange(isShow) {
        setSuccess(!isShow);
        [...document.getElementsByClassName("right-title")].forEach(item => item.style.display = isShow ? "block" : "none");
        [...document.getElementsByClassName("right-subTitle")].forEach(item => item.style.display = isShow ? "block" : "none")
    }

    function rememUserBack() {
        let { email, rememUser } = getUserInfo()
        setChecked(rememUser)
        if (rememUser && email && getSetting().isLogin || (saveLogin.email)) {
            for (let i = 1; i < 3; i++) {
                let form = eval(`form${i}`)
                form.email = email
                inputEvent(null, i, email, document.getElementById(`lable-input-email-${i}`))
                document.getElementById(`lable-input-email-${i}`).value = email
                document.getElementById(`lable-input-email-${i}`).dispatchEvent(new Event("blur"))
            }
        }
    }

    useEffect(() => {
        debounce(() => {
            buriedPoints("Freemium_Register popup", {
                Page: getSetting().originHref,
                Source: getSetting().source || "",
                ...defaultParams
            })
        }, 100)
    }, [])
    useEffect(() => {
        let event = 'orientationchange' in window ? 'orientationchange' : 'resize'
        document.addEventListener('DOMContentLoaded', setViewHeight)
        window.addEventListener(event, setViewHeight)
        setViewHeight()
        return () => {
            document.removeEventListener('DOMContentLoaded', setViewHeight)
            window.removeEventListener(event, setViewHeight)
        }
    }, [])
    function setViewHeight() {
        try {
            let windowH = window.innerHeight / 100
            document.body.style.setProperty('--vh', windowH + 'px')
        } catch {
            document.body.style.setProperty('--vh', '1vh')
        }
    }

    function getUserInfo() {
        return {
            rememUser: saveLogin.rememUser !== undefined ? saveLogin.rememUser : getSetting().userInfo && getSetting().userInfo.rememUser || false,
            email: saveLogin.email || getSetting().userInfo && getSetting().userInfo.email || "",
        }
    }

    const submitClick = () => {
        const btn = document.getElementById('submit-btn-1')
        if ((!getSetting().new && !getSetting().isLogin) || ![...btn.classList].includes("can-click")) return;
        login(loginForm, 1)
    }

    return (<div>
        <div className="register-form">
            {success && !setting.onlyForm ? <></> : <>
                <div className="right-title" style={{ cursor: "default" }}>{descWords.title}</div>
                <div className="right-subTitle">
                    {!setting.isLogin && <Tips />}
                </div></>}
            <div className="registor-none" id="registor-none-1">
                <form>
                    <div>
                        <div className="each-input-con">
                            <input className="input email" autoComplete="new-password" hidden
                                maxLength="512" id="lable-input-email-1"></input>
                            <label htmlFor="lable-input-email-1" className="input-label ">Email Address</label>
                            <div className="form-error form-requried">Please complete this required field</div>
                            <div className="form-error">Invalid email format</div>
                            {!getSetting().isLogin && <div className="form-error form-already">Already a COMMAND member. <a
                                href="javascript: void(0)" className="loginWord blue" onClick={loginWordClick}>Please login
                                in</a></div>}
                        </div>
                        <div className="each-input-con">
                            <div className="icon-eye" id="eye-1" onClick={() => setEye1Show(!eye1Show)}>
                                {!eye1Show ?
                                    EyeOff :
                                    <img src="./images/Eye-On.png" alt="" />
                                }
                            </div>
                            <input className="input password" autoComplete="new-password" hidden
                                maxLength="150" type={!eye1Show ? "password" : 'text'} id="lable-input-password-1"></input>
                            <label htmlFor="lable-input-password-1" className="input-label ">Password</label>
                            <div className="form-error form-requried">Please complete this required field</div>
                            <div className="form-error">Password needs at least 4 characters</div>
                        </div>
                    </div>
                    {setting.isLogin && <div className="rem-forget">
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                            <input type="checkbox" checked={checked} style={{ margin: "0 4px 0 0" }}
                                onChange={e => setChecked(e.target.checked)} />
                            <span className="reme-user">Remember me</span>
                        </label>
                        <div className="forget-password" onClick={() => {
                            setSaveLogin({ ...loginForm, rememUser: checked })
                            setTimeout(() => {
                                setSetting({ isForgetPassword: true })
                            }, 0)
                        }}>Forgot password?</div>
                    </div>}
                    <div className="submit-btn" id="submit-btn-1" style={{ marginTop: setting.isLogin ? "16px" : "24px" }}
                        onClick={submitClick}
                    >{descWords.btnTitle}
                    </div>
                    {
                        setting.isLogin && <div className="sso-btn" onClick={() => {
                            setSaveLogin({ ...loginForm, rememUser: checked })
                            setTimeout(() => {
                                setSetting({ isSSO: true })
                            }, 0)
                        }}>
                            CONTINUE WITH SINGLE SIGN-ON
                        </div>
                    }

                </form>
                <div className="privacy" style={{ cursor: "default" }}>
                    By {descWords.policyWord}, you agree to our
                    <a href="https://www.truckerpath.com/privacy-policy/" className="blue" target={'_blank'}> Privacy
                        Policy</a> and
                    <a href="https://www.truckerpath.com/terms-of-service/" className="blue" target={'_blank'}> Terms and Conditions</a>
                </div>
                {(!setting.onlyForm && setting.isLite !== true) && <div className="have-account" style={{ cursor: "default" }}>
                    {descWords.bottomWord} <a href="javascript:;" className="blue" onClick={loginWordClick}>{descWords.guideWord}</a></div>}
            </div>

            <div className="registor-loading" id="registor-loading-1">
                <img src="./images/Icon-Loading.svg" alt="" />
            </div>

            <div className="registor-success" id="registor-success-1">
                <div className="success-check"><img src="./images/Email.svg" alt="" /><span>Check Your Email</span></div>
                <div className="success-word" id="success-word-1">
                    To activate your account, click the link we sent to <b className="success-email">email</b>. Make sure to check your spam folder.</div>
                <div className="success-noget">Didn't get the email?</div>
                <div className="resend-btn" id="resend-btn-1">Resend your email</div>
            </div>

        </div>
        <div className='h5'>
            <div className="header-con">
                <div className="header layout">
                    <div className="header-one"><img src="./images/Logo.svg" alt="" /></div>
                    <div className="header-two">
                        <a href="mailTo: commandsupport@truckerpath.com">
                            <img src="./images/email.png" alt="" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="h5-register" id="h5-register">
                <div className="h5-header">
                    <div className="h5-desc">{setting.title}</div>
                    {setting.showH5Close && <img src="./images/close.png" alt="" className="close-icon" id="closeIcon" onClick={closeAll} />
                    }
                </div>
                <div className="registor-none h5-register-content" id="registor-none-2">
                    <div className="h5-input-con">
                        <div className="each-input-con">
                            <input className="input email" autoComplete="new-password" hidden maxLength="512"
                                id="lable-input-email-2"></input>
                            <label htmlFor="lable-input-email-2" className="input-label ">Email Address</label>
                            <div className="form-error form-requried">Please complete this required field</div>
                            <div className="form-error">Invalid email format</div>
                            <div className="form-error form-already">Already a COMMAND member. <a
                                href="javascript: void(0)" className="loginWord blue" onClick={loginWordClick} >Please login
                                in</a></div>
                        </div>
                        <div className="each-input-con">
                            <div className="icon-eye" id="eye-2" onClick={() => setEye2Show(!eye2Show)}>
                                {!eye2Show ?
                                    <img src="./images/Eye-Off.png" alt="" /> :
                                    <img src="./images/Eye-On.png" alt="" />
                                }
                            </div>
                            <input className="input password" autoComplete="new-password" hidden maxLength="150"
                                type={!eye2Show ? "password" : 'text'} id="lable-input-password-2"></input>
                            <label htmlFor="lable-input-password-2" className="input-label ">Password</label>
                            <div className="form-error form-requried">Please complete this required field</div>
                            <div className="form-error">Password needs at least 4 characters</div>
                        </div>

                        <div className="privacy">
                            By registering, you agree to our
                            <a href="javascript:;" className="blue"
                                onClick={() => h5LinkClick("https://www.truckerpath.com/privacy-policy/")}> Privacy </a>
                            <a href="javascript:;" className="blue"
                                onClick={() => h5LinkClick("https://www.truckerpath.com/privacy-policy/")}>Policy </a>
                            and
                            <a href="javascript:;" className="blue"
                                onClick={() => h5LinkClick("https://www.truckerpath.com/terms-of-service/")}> Terms </a>
                            <a href="javascript:;" className="blue"
                                onClick={() => h5LinkClick("https://www.truckerpath.com/terms-of-service/")}>and </a>
                            <a href="javascript:;" className="blue"
                                onClick={() => h5LinkClick("https://www.truckerpath.com/terms-of-service/")}>Conditions</a>
                        </div>
                        <div style={{ width: "1px", height: "80px" }}></div>
                    </div>
                    <div className="h5-bottom">
                        <div className="h5-submit" id="submit-btn-2" >
                            {"SUBMIT"}
                        </div>
                    </div>
                </div>
                <div className="registor-loading h5-register-content" id="registor-loading-2">
                    <img src="./images/Icon-Loading.svg" alt="" />
                </div>
                <div className="registor-success h5-register-content" id="registor-success-2">
                    <div className="success-content">
                        <img src="./images/SuceessNew.svg" alt="" />
                        <div className="success-check"><span>Check Your Email</span></div>
                        <div className="success-word" id="success-word-2">
                            To activate your account, click the link we sent to
                            <b className="success-email">email</b>
                            . Make sure to check your spam folder.
                        </div>
                    </div>
                    <div className="success-noget">Didn't get the email?</div>
                    <div className="resend-btn" id="resend-btn-2">Resend your email</div>
                </div>
            </div>
        </div>
    </div>)
}